module.exports = __webpack_public_path__ + "img/Ranger.7af2270d.png";